import { render, staticRenderFns } from "./ServiceBundle.vue?vue&type=template&id=28102cd0&"
import script from "./ServiceBundle.vue?vue&type=script&lang=js&"
export * from "./ServiceBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ServiceBundle.vue"
export default component.exports